import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/comment-forum'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  add(comment) {
    return http.post(`${resource}`, comment)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
